import { render, staticRenderFns } from "./EditorLogin.vue?vue&type=template&id=4841f778&scoped=true&"
import script from "./EditorLogin.vue?vue&type=script&lang=js&"
export * from "./EditorLogin.vue?vue&type=script&lang=js&"
import style0 from "./EditorLogin.vue?vue&type=style&index=0&id=4841f778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4841f778",
  null
  
)

export default component.exports